import { render, staticRenderFns } from "./TwoFactorComponent.vue?vue&type=template&id=15c4a000&"
import script from "./TwoFactorComponent.vue?vue&type=script&lang=ts&"
export * from "./TwoFactorComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TwoFactorComponent.vue?vue&type=style&index=0&id=15c4a000&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports